/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./app', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Init Pinia
import { createPinia, PiniaVuePlugin } from 'pinia';
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// Page contents component
new Vue({
  el: '#app',
  pinia,
});

if (window.app_type !== 'customer-select') {
  if (window.app_type === `third-party-uploader`) {
    new Vue({
      el: '#admin_link',
    });
  }

  if (window.app_type !== 'third-party-uploader') {
    // Additional components outside contents
    new Vue({
      el: '#notifications',
    });

    new Vue({
      el: '#navigation',
    });

    if (window.app_type === 'app') {
      new Vue({
        el: '#quick_start_button',
      });

      new Vue({
        el: '#analytics_link',
      });

      new Vue({
        el: '#global_search',
      });

      new Vue({
        el: '#customer_switcher',
      });

      new Vue({
        el: '#admin_link',
      });

      new Vue({
        el: '#revert_plan_link',
      });

      // id'd element doesn't exist if popup doesn't exist (so after user accepts)
      if (document.querySelector(`#timbre_cookies_list`)) {
        new Vue({
          el: '#timbre_cookies_list',
        });
      }
    }
  }
}
